export enum OriginalStatus {
    ACCEPTED = "Accepted",
    REJECTED = "Rejected"
}
